import { linkSearchItems } from "components/v2/Listings/ListingsRouterUrlHelper";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingreducerSelectors } from "redux/slices/v2/ListingReducer";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import formatUrl from "utils/FormatUrl";
import Dropdown from "../DropDown/DropDown";
import DropDownComponent from "./DropDownComponent";
import classes from "./SaveSearch.module.css";
export const buildLink = (searchPayload, lang, onReturn) => {
  let copySP = {};
  if (window.cartedesannonces) {
    if (window.cartedesannonces.getBounds) {
      let boundsref = window.cartedesannonces.getBounds();
      copySP["lat"] = window.cartedesannonces.getCenter().lat;
      copySP["lng"] = window.cartedesannonces.getCenter().lng;
      copySP["zoom"] = window.cartedesannonces.getZoom();
      copySP["bounds"] = [
        boundsref._sw.lat,
        boundsref._sw.lng,
        boundsref._ne.lat,
        boundsref._ne.lng,
      ];
    }
  } else if (searchPayload.bounds) {
    copySP["bounds"] = [
      searchPayload.bounds._sw.lat,
      searchPayload.bounds._sw.lng,
      searchPayload.bounds._ne.lat,
      searchPayload.bounds._ne.lng,
    ];
  }

  linkSearchItems.map((item) => {
    if (
      (searchPayload[item] && searchPayload[item].length) ||
      (typeof searchPayload[item] == "number" &&
        parseInt(searchPayload[item].toString()))
    ) {
      copySP[item] = searchPayload[item];
    }
  });

  const u = new URLSearchParams(copySP).toString();

  let link = `https://agenz.ma${formatUrl(
    `list.htm${u ? `?${u}` : ""}`,
    lang
  )}`;

  onReturn(link);
  // setCustomLink(link);
  return link;
};
const SaveSearch = () => {
  const [dropdownToggle, setDropdownToggle] = useState<boolean>(false);
  const { t, lang } = useTranslation("commonAnnonces");
  const [isMobile, setIsMobile] = useState(true);
  const [displayCopyLink, setDisplayCopyLink] = useState(false);
  const [errorField, setErrorField] = useState(false);
  const [customLink, setCustomLink] = useState("");
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    setDisplayCopyLink(false);
  }, [dropdownToggle]);
  const searchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  const searchAdresse = useSelector(ListingreducerSelectors.adresseSelector);
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    setInputValue(
      `${
        searchPayload.transaction_type == "Projets Neufs"
          ? t("Projets neufs")
          : searchPayload.transaction_type == "Vente"
          ? t("À vendre")
          : t("À louer")
      } ${
        searchAdresse
          ? searchAdresse
          : searchPayload.commune
          ? `à ${searchPayload.commune}`
          : searchPayload.province
          ? `à ${searchPayload.province}`
          : searchPayload.region
          ? `à ${searchPayload.region}`
          : ""
      }`
    );
  }, [searchPayload]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 990) setIsMobile(true);
      else setIsMobile(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (window.innerWidth <= 990) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  const addFilter = (filterName, value) => {
    const first = [filterName, value].join("=");
    return first;
  };

  const arrayToString = (array) => {
    const theCustomString = array.join(",");
    return ["[", theCustomString, "]"].join("");
  };

  const [saving, setSaving] = useState(false);
  const handleUpdateSearch = async () => {
    setSaving(true);

    let link = buildLink(searchPayload, lang, (link) => {
      setCustomLink(link);
    });

    if (inputValue !== "") {
      let bounds = null;
      if (window.cartedesannonces) {
        if (window.cartedesannonces.getBounds) {
          let boundsref = window.cartedesannonces.getBounds();
          bounds = [
            boundsref._sw.lat,
            boundsref._sw.lng,
            boundsref._ne.lat,
            boundsref._ne.lng,
          ];
        }
      } else if (searchPayload.bounds) {
        bounds = [
          searchPayload.bounds._sw.lat,
          searchPayload.bounds._sw.lng,
          searchPayload.bounds._ne.lat,
          searchPayload.bounds._ne.lng,
        ];
      }

      api_call_v2(
        undefined,
        "post",
        "search/save",
        {
          title: inputValue,
          criteria: {
            ...searchPayload,
            bounds: bounds,
            center: searchPayload.lat
              ? [searchPayload.lat, searchPayload.lng]
              : null,
            zoom: searchPayload.zoom ? searchPayload.zoom : null,
            url: link,
          },
        },
        "v3",
        true
      )
        .then((res) => {
          setSaving(false);
          setDisplayCopyLink(true);
        })
        .catch((err) => {
          setSaving(false);
        });
    } else {
      setSaving(false);
      setErrorField(true);
      setDisplayCopyLink(false);
    }
  };

  const copyMail = () => {
    navigator.clipboard.writeText(customLink);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const valueComponent = (
    <>
      <div className={classes.label} data-tracking="click" data-value="">
        <div className={classes.alertIcon}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7503 13.5833H16.3337L15.0458 12.2955C14.6965 11.9462 14.5003 11.4725 14.5003 10.9786V8.08334C14.5003 5.6886 12.9698 3.65133 10.8337 2.8963V2.58333C10.8337 1.57081 10.0128 0.75 9.00033 0.75C7.9878 0.75 7.16699 1.57081 7.16699 2.58333V2.8963C5.03081 3.65133 3.50033 5.6886 3.50033 8.08334V10.9786C3.50033 11.4725 3.30411 11.9462 2.95485 12.2955L1.66699 13.5833H6.25033M11.7503 13.5833V14.5C11.7503 16.0188 10.5191 17.25 9.00033 17.25C7.48154 17.25 6.25033 16.0188 6.25033 14.5V13.5833M11.7503 13.5833H6.25033"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        {t(isMobile ? "M'alerter" : "Activer l'alerte")}
      </div>
    </>
  );
  return (
    <>
      <Dropdown
        hideIcon={true}
        t={t}
        className={`${classes.buttonWrapper}`}
        liststyling={classes.styles}
        contentComponent={
          <DropDownComponent setDropdownToggles={setDropdownToggle} isModal={true} />
        }
        valueComponent={valueComponent}
        toggleBtnStyle={classes.toggleBtnStyle}
        onToggleActive={classes.toggleBtnActive}
        dropdownToggle={dropdownToggle}
        setDropdownToggle={setDropdownToggle}
      />
    </>
  );
};

export default SaveSearch;
